import {
  authHeader,
  config,
  handleResponse,
  handleError,
  getLocale,
  history,
} from "../../common/helpers";

function getUserNotificationCount(userAccountId) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
  };
  const url =
    config.flukeIotApiUrl + "/user/" + userAccountId + "/unreadnotification";

  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function postUserSettings(preferences_data) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify([preferences_data]),
  };

  const url = config.apiUrl + "/userpreference";

  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function postUpdateUser(user_details) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user_details),
  };

  const url = config.apiUrl + "/user";
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function postFeedback(user_feedback) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(user_feedback),
  };

  const url = config.apiUrl + "/email/feedback";
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function postChangePassword(user_credentials, id) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user_credentials),
  };

  const url = config.apiUrl + `user/${id}/setpassword`;
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function setUserPassword(id, password, opts = {}) {  
  const keepKeys = new Set(["oldPword", "passwordResetId"]);
  const data = {
    newPword: password,
    ...Object.fromEntries(
      Object.entries(opts).filter(
        ([key, value]) =>
          keepKeys.has(key) && value !== null && value !== undefined
      )
    ),
  };

  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  const url = config.apiUrl + `/user/${id}/setpassword`;

  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function initiateDataExport(includeMedia = true) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json", "XT-Locale": getLocale(history?.location?.pathname ?? "/") },
    body: JSON.stringify({ includeMedia }),
  };
  return fetch(config.apiUrl + "/organization/data-export", requestOptions).then(handleResponse, handleError);
}

function initiateMixpanelExport() {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "XT-Locale": getLocale(history?.location?.pathname ?? "/") },
  };
  return fetch(config.apiUrl + `/organization/data-export/mixpanel`, requestOptions).then(handleResponse, handleError);
}

function getOrgDataExports(orgId) {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json", "XT-Locale": getLocale(history?.location?.pathname ?? "/") },
  };
  return fetch(config.apiUrl + `/organization/${orgId}/data-export`, requestOptions).then(handleResponse, handleError);
}

export {
  getUserNotificationCount,
  postUserSettings,
  postUpdateUser,
  postFeedback,
  postChangePassword,
  setUserPassword,
  initiateDataExport,
  getOrgDataExports,
  initiateMixpanelExport,
};
